var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailed = function SvgFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.94 4 4 12.94 4 24s8.94 20 20 20 20-8.94 20-20S35.06 4 24 4m10 27.18L31.18 34 24 26.82 16.82 34 14 31.18 21.18 24 14 16.82 16.82 14 24 21.18 31.18 14 34 16.82 26.82 24z"
  })));
};
export default SvgFailed;